import { AbstractGoHeuristic } from '../AbstractGoHeuristic';
import { HexagonalGoRules } from './HexagonalGoRules';
export class HexagonalGoHeuristic extends AbstractGoHeuristic {
    constructor() {
        super(HexagonalGoRules.get());
    }
}
